import React, { useMemo } from 'react';

const OLIVE = '58,74,41';

function DotWavesS({ sidebarExpanded = false }) {
    const dots = useMemo(() => {
        const acc = [];
        const cx = 100;
        const cy = 0;
        const nArcs = 12;
        const dotsPerArc = 34;
        const rMin = 12;
        const rMax = 72;
        const angleStart = Math.PI * 0.52;
        const angleEnd = Math.PI * 1.0;

        for (let i = 0; i < nArcs; i++) {
            const r = rMin + (i / (nArcs - 1)) * (rMax - rMin);
            const opBase = 0.6 - (i / (nArcs - 1)) * 0.25;
            for (let j = 0; j < dotsPerArc; j++) {
                const angle = angleStart + (j / (dotsPerArc - 1)) * (angleEnd - angleStart);
                const x = cx + r * Math.cos(angle);
                const y = cy + r * Math.sin(angle);
                if (x < -2 || x > 102 || y < -2 || y > 102) continue;
                acc.push({ x, y, op: opBase, id: `${i}-${j}` });
            }
        }
        return acc;
    }, []);

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                right: sidebarExpanded ? 280 : 0,
                width: sidebarExpanded ? 'calc(100% - 280px)' : '100%',
                height: '100%',
                zIndex: 2,
                pointerEvents: 'none',
                overflow: 'hidden',
                transition: 'right 0.3s ease-out, width 0.3s ease-out',
            }}
            aria-hidden
        >
            {dots.map(({ x, y, op, id }) => (
                <div
                    key={id}
                    style={{
                        position: 'absolute',
                        left: `${x}%`,
                        top: `${y}%`,
                        width: 3,
                        height: 3,
                        borderRadius: '50%',
                        backgroundColor: `rgba(${OLIVE},${op})`,
                    }}
                />
            ))}
        </div>
    );
}

export default DotWavesS;
